// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Select,
//   Upload,
//   Card,
//   message,
//   Layout,
//   Image,
//   Divider,
//   Space,
//   Menu,
//   Radio,
//   Checkbox,
// } from "antd";
// import {
//   UploadOutlined,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
// } from "@ant-design/icons";
// import Sider from "antd/es/layout/Sider";
// import { Header } from "antd/es/layout/layout";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import "./UserRules.css"
// const { TextArea } = Input;
// const { Content } = Layout;

// const UserRules = () => {
//   const [form] = Form.useForm();
//   const navigate = useNavigate();
//   const [agreed, setAgreed] = useState(false);

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isMobile={isMobile} role="user" />
//       <Layout
//         style={{
//           marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
//           transition: "0.3s ease",
//           width: "100%",
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           <Button
//             type="text"
//             icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//             onClick={() => {
//               if (isMobile) {
//                 setMobileOpen(true);
//               } else {
//                 setCollapsed(!collapsed);
//               }
//             }}
//             style={{ fontSize: 18, width: 64, height: 64 }}
//           />
//           <h2 style={{ margin: 0 }}>Users Rules & Regulations</h2>
//         </Header>

//         <div className="guidelines-page">
//           {/* HERO */}
//           <div className="guidelines-hero">
//             <h1>Guidelines for Uploading Yoga Images</h1>
//             <p>
//               Help us build the world’s most trusted yoga reference library 🌍
//             </p>
//           </div>

//           <div className="guidelines-container">
//             <section className="guideline-section">
//               <h2>📋 Basic Eligibility & Rights</h2>

//               <div className="rule-card success">
//                 <h4>✅ Only Your Own Photos</h4>
//                 <ul>
//                   <li>Photos taken by you</li>
//                   <li>Written permission required if not</li>
//                   <li>AI-generated images are not allowed</li>
//                 </ul>
//               </div>

//               <div className="rule-card warning">
//                 <h4>👶 Permission from Others</h4>
//                 <ul>
//                   <li>Consent required for anyone in the image</li>
//                   <li>Children require parent/guardian approval</li>
//                 </ul>
//               </div>

//               <div className="rule-card info">
//                 <h4>📜 Licensing Agreement</h4>
//                 <ul>
//                   <li>We only have the right to show it for the rest of our lives.</li>
//                   <li>Resize allowed if required</li>
//                   <li>Your creator rights remain with you</li>
//                 </ul>
//               </div>
//             </section>

//             {/* IMAGE QUALITY */}
//             <section className="guideline-section">
//               <h2>🖼️ Image Quality Rules</h2>

//               <div className="two-column">
//                 <div className="rule-card success">
//                   <h4>📸 Shooting Method</h4>
//                   <ul>
//                     <li>Yoga mat only</li>
//                     <li>Natural daylight</li>
//                     <li>Clear & steady shots</li>
//                     <li>Yoga-appropriate clothing</li>
//                   </ul>
//                 </div>

//                 <div className="rule-card danger">
//                   <h4>🚫 Things to Avoid</h4>
//                   <ul>
//                     <li>Watermarks / logos</li>
//                     <li>AI filters or face changers</li>
//                     <li>Dangerous locations</li>
//                     <li>Over-saturated colors</li>
//                   </ul>
//                 </div>
//               </div>
//             </section>

//             {/* TECHNICAL DETAILS */}
//             <section className="guideline-section">
//               <h2>📱 Technical Details</h2>

//               <table className="guidelines-table">
//                 <thead>
//                   <tr>
//                     <th>Item</th>
//                     <th>Requirement</th>
//                     <th>Tip</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>File Size</td>
//                     <td>Up to 3MB</td>
//                     <td>Mobile photos are enough</td>
//                   </tr>
//                   <tr>
//                     <td>Format</td>
//                     <td>.jpg, .png, .webp</td>
//                     <td>.jpg recommended</td>
//                   </tr>
//                   <tr>
//                     <td>Resolution</td>
//                     <td>HD (1920×1080)</td>
//                     <td>Book-quality clarity</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </section>

//             {/* UPLOAD PROCESS */}
//             <section className="guideline-section">
//               <h2>📤 Upload Process</h2>

//               <ol className="steps">
//                 <li>Go to upload page</li>
//                 <li>Select photo (≤ 3MB)</li>
//                 <li>Fill pose & creator details</li>
//                 <li>Submit for review</li>
//               </ol>

//               <div className="rule-card info">
//                 <strong>⏱ Review Time:</strong> 24–48 hours (weekends may vary)
//               </div>
//             </section>

//             {/* VIOLATIONS */}
//             <section className="guideline-section">
//               <details className="accordion">
//                 <summary>⚖️ Rule Violations & Penalties</summary>
//                 <ul>
//                   <li>1st: Warning + removal</li>
//                   <li>2nd: 7-day upload block</li>
//                   <li>3rd: 30-day account block</li>
//                   <li>4th: Permanent ban</li>
//                 </ul>
//               </details>
//             </section>

//             {/* CHECKLIST */}
//             {/* <section className="guideline-section">
//               <h2>✅ Final Acknowledgement</h2>

//               <div className="final-checklist">
//                 <label>
//                   <input
//                     type="checkbox"
//                     onChange={(e) => setAgreed(e.target.checked)}
//                   />
//                   I confirm that I have read and understood all rules
//                 </label>
//               </div>

//               <button className="primary-btn" disabled={!agreed}>
//                 Proceed to Upload
//               </button>
//             </section> */}
//           </div>
//         </div>
//       </Layout>
//     </Layout>
//   );
// };

// export default UserRules;

import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Layout,
  Typography,
  Table,
  Tag,
  Alert,
  Collapse,
  Divider,
} from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileImageOutlined,
  ClockCircleOutlined,
  SafetyCertificateOutlined,
  QuestionCircleOutlined,
  WarningOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Header } from "antd/es/layout/layout";
import { Content } from "antd/es/layout/layout";
import Sidebar from "../Components/Sidebar";

const { Text, Paragraph } = Typography;
const { Panel } = Collapse;

// Scrollable wrapper for all tables so they never overflow on narrow screens
const ScrollTable = ({ style, ...props }) => (
  <div
    style={{ overflowX: "auto", WebkitOverflowScrolling: "touch", ...style }}
  >
    <Table {...props} />
  </div>
);

// ─────────────────────────────────────────────
// RULES PAGE CONTENT
// ─────────────────────────────────────────────

const RulesContent = ({ isMobile }) => {
  const imageQualityAllowed = [
    {
      key: 1,
      category: "Ownership",
      description: "Only photos you have taken yourself.",
    },
    {
      key: 2,
      category: "Permission",
      description:
        "Written permission is required if other people appear in the photo.",
    },
    {
      key: 3,
      category: "Children",
      description:
        "Parental consent is mandatory for photos featuring children.",
    },
  ];

  const imageQualityNotAllowed = [
    {
      key: 1,
      category: "AI Images",
      description: "AI-generated images are not accepted.",
    },
    {
      key: 2,
      category: "Copyright",
      description: "Using images taken by others is not allowed.",
    },
    {
      key: 3,
      category: "Watermarks",
      description: "Images containing watermarks will be rejected.",
    },
  ];

  const imageCriteria = [
    {
      key: 1,
      aspect: "Background",
      correct: "Yoga mat, white or single-colour background",
      avoid: "Dangerous locations such as heights or near water",
    },
    {
      key: 2,
      aspect: "Lighting",
      correct: "Well-lit environment",
      avoid: "Dim or poorly lit conditions",
    },
    {
      key: 3,
      aspect: "Equipment",
      correct: "A mobile phone camera is sufficient",
      avoid: "Images with watermarks or heavy filters",
    },
    {
      key: 4,
      aspect: "Expression",
      correct: "Natural facial expression",
      avoid: "Heavy AI filters applied to the face",
    },
    {
      key: 5,
      aspect: "Clothing",
      correct: "Comfortable, plain clothing",
      avoid: "Clothing with visible brand logos",
    },
  ];

  const technicalDetails = [
    {
      key: 1,
      detail: "File Size",
      requirement: "Up to 3 MB",
      note: "Mobile phone photos are sufficient",
    },
    {
      key: 2,
      detail: "Format",
      requirement: ".jpg, .png, .webp",
      note: ".jpg is recommended",
    },
    {
      key: 3,
      detail: "Resolution",
      requirement: "HD (1920 x 1080)",
      note: "Standard mobile camera quality is acceptable",
    },
    {
      key: 4,
      detail: "File Name",
      requirement: "In English",
      note: "Example: trikonasana.jpg",
    },
  ];

  const uploadLimits = [
    { key: 1, period: "Per Day", limit: "10 images" },
    { key: 2, period: "Per Week", limit: "50 images" },
    { key: 3, period: "Total Lifetime", limit: "200 images" },
  ];

  const processingTime = [
    { key: 1, day: "Weekdays", time: "Review within 24–48 hours" },
    { key: 2, day: "Weekends", time: "Slight delay expected" },
    { key: 3, day: "High-quality images", time: "Faster approval" },
  ];

  const extensionSequence = [
    {
      key: 1,
      sequence: "1st Image",
      extension: "6 months",
      action: "No action required — just upload.",
    },
    {
      key: 2,
      sequence: "2nd Image",
      extension: "+1 month",
      action: "Share the website once on social media.",
    },
    {
      key: 3,
      sequence: "3rd Image",
      extension: "+15 days",
      action: "Share the website once on social media.",
    },
    {
      key: 4,
      sequence: "4th to 20th",
      extension: "+10 days each",
      action: "Share the website once per image uploaded.",
    },
    {
      key: 5,
      sequence: "21st to 200th",
      extension: "+1 day each",
      action: "No sharing required.",
    },
  ];

  const paidPlans = [
    {
      key: 1,
      plan: "Basic 1",
      duration: "1 month",
      p1: "$1 / $2",
      p2: "$2 / $3",
      p3: "$3 / $4",
      p4: "$5 / $6",
    },
    {
      key: 2,
      plan: "Basic 2",
      duration: "3 months",
      p1: "$3 / $5",
      p2: "$6 / $8",
      p3: "$9 / $11",
      p4: "$15 / $18",
    },
    {
      key: 3,
      plan: "Standard",
      duration: "6 months",
      p1: "$5 / $8",
      p2: "$10 / $13",
      p3: "$15 / $18",
      p4: "$30 / $35",
    },
    {
      key: 4,
      plan: "Premium",
      duration: "1 year",
      p1: "$10 / $15",
      p2: "$20 / $25",
      p3: "$30 / $35",
      p4: "$50 / $60",
    },
  ];

  const creatorAwards = [
    {
      key: 1,
      images: 25,
      award: "Basic",
      benefit: "1 month media link extension",
    },
    {
      key: 2,
      images: 50,
      award: "Silver",
      benefit: "2 months media link extension",
    },
    {
      key: 3,
      images: 75,
      award: "Gold",
      benefit: "3 months media link extension",
    },
    {
      key: 4,
      images: 100,
      award: "Diamond",
      benefit: "5 months media link extension",
    },
    {
      key: 5,
      images: 200,
      award: "Platinum",
      benefit: "6 months media link extension",
    },
  ];

  const penalties = [
    {
      key: 1,
      offense: "First",
      penalty: "Warning + Image removal",
      appeal: "Handled automatically",
    },
    {
      key: 2,
      offense: "Second",
      penalty: "7-day ban",
      appeal: "Email help@yogarefer.com",
    },
    {
      key: 3,
      offense: "Third",
      penalty: "30-day ban",
      appeal: "Submit an appeal with evidence",
    },
    {
      key: 4,
      offense: "Fourth",
      penalty: "Permanent ban",
      appeal: "Legal action may follow",
    },
  ];

  const directBan = [
    {
      key: 1,
      reason: "Copyright Infringement",
      description: "Using images taken by someone else.",
    },
    {
      key: 2,
      reason: "Obscene Content",
      description: "Images that are inappropriate for a yoga platform.",
    },
    {
      key: 3,
      reason: "AI-Generated Images",
      description: "Images created using artificial intelligence tools.",
    },
  ];

  const mediaLinkCounting = [
    {
      key: 1,
      example: "Padmasana in Anantasana",
      count: "2 media links",
      note: "Padmasana + Anantasana",
    },
    {
      key: 2,
      example: "Ardha Padma Naginyasana in Anantasana",
      count: "3 media links",
      note: "Padmasana + Naginiyasana + Anantasana",
    },
  ];

  const freeExtensionPlans = [
    {
      key: 1,
      plan: "Basic 1",
      action: "1 post about yogarefer.com on any social media",
      p1: "1 month / 15 days",
      p2: "15 days / 10 days",
      p3: "10 days / 5 days",
      p4: "5 days / 3 days",
    },
    {
      key: 2,
      plan: "Basic 2",
      action: "Share on 3 social media platforms",
      p1: "3 months / 45 days",
      p2: "45 days / 30 days",
      p3: "30 days / 20 days",
      p4: "15 days / 10 days",
    },
    {
      key: 3,
      plan: "Standard",
      action: "Share on 6 social media platforms",
      p1: "6 months / 3 months",
      p2: "3 months / 45 days",
      p3: "2 months / 45 days",
      p4: "1 month / 20 days",
    },
    {
      key: 4,
      plan: "Premium",
      action:
        "Write a blog/review + share on 6 platforms + share in yoga groups",
      p1: "12 months / 6 months",
      p2: "6 months / 3 months",
      p3: "4 months / 2 months",
      p4: "2 months / 1 month",
    },
  ];

  const sharingRules = [
    {
      key: 1,
      rule: "Proof Required",
      description: "You must send a screenshot as proof of sharing.",
    },
    {
      key: 2,
      rule: "Time Limit",
      description: "Sharing must be done within 48 hours of uploading.",
    },
    {
      key: 3,
      rule: "Visibility",
      description: "The post must be set to Public.",
    },
    {
      key: 4,
      rule: "Hashtag",
      description: "Include #YogaRefer and #YogaWith[YourName].",
    },
    { key: 5, rule: "Tag", description: "Mention @yogarefer in the post." },
  ];

  const followerBonus = [
    { key: 1, followers: "> 1,000", mediaOnly: "15 days", withLogo: "10 days" },
    {
      key: 2,
      followers: "> 10,000",
      mediaOnly: "1 month",
      withLogo: "20 days",
    },
    {
      key: 3,
      followers: "> 50,000",
      mediaOnly: "3 months",
      withLogo: "2 months",
    },
    {
      key: 4,
      followers: "> 100,000",
      mediaOnly: "6 months",
      withLogo: "4 months",
    },
    {
      key: 5,
      followers: "> 1,000,000",
      mediaOnly: "10 months",
      withLogo: "8 months",
    },
  ];

  const privacyData = [
    { key: 1, type: "Images", period: "Permanent (Lifetime, free)" },
    { key: 2, type: "User Data", period: "5 years" },
    { key: 3, type: "Upload Details", period: "3 years" },
    { key: 4, type: "Extension History", period: "7 years" },
  ];

  const userRights = [
    {
      key: 1,
      right: "Delete Account",
      description: "You may delete your account at any time.",
    },
    {
      key: 2,
      right: "Delete Images",
      description: "Images will be removed within 15 days of your request.",
    },
    {
      key: 3,
      right: "Export Data",
      description: "Your data can be exported in PDF or Excel format.",
    },
    {
      key: 4,
      right: "Stop Advertisements",
      description: "You can turn off advertisements in your Settings.",
    },
  ];

  const colStyle = { title: { background: "#fafafa" } };
  const panelStyle = {
    marginBottom: 12,
    border: "1px solid #f0f0f0",
    borderRadius: 8,
    background: "#fff",
  };
  const sectionGap = { marginBottom: 16 };

  const SectionTitle = ({ icon, children }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 10,
        marginTop: 4,
      }}
    >
      {icon}
      <Text strong style={{ fontSize: isMobile ? 13 : 15 }}>
        {children}
      </Text>
    </div>
  );

  // On mobile, render wide multi-column tables as stacked info cards instead
  const MobileCard = ({ items }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: 8,
            padding: "10px 12px",
            background: "#fafafa",
          }}
        >
          {Object.entries(item)
            .filter(([k]) => k !== "key")
            .map(([k, v]) => (
              <div key={k} style={{ marginBottom: 4 }}>
                <Text
                  type="secondary"
                  style={{ fontSize: 11, textTransform: "capitalize" }}
                >
                  {k.replace(/([A-Z])/g, " $1")}
                </Text>
                <div>
                  <Text style={{ fontSize: 13 }}>{v}</Text>
                </div>
              </div>
            ))}
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ maxWidth: 860, margin: "0 auto" }}>
      {/* Goal */}
      <Alert
        message="Our Goal"
        description="To provide quality references for yoga practitioners worldwide and to give recognition to the creators who contribute."
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 16 }}
      />

      {/* Quick Reference */}
      <Card
        title={
          <>
            <FileImageOutlined style={{ marginRight: 8 }} />
            Quick Reference
          </>
        }
        style={{ marginBottom: 16 }}
        styles={colStyle}
        size={isMobile ? "small" : "default"}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: isMobile ? "10px" : "10px 24px",
          }}
        >
          {[
            [
              "Image Requirements",
              "White background · HD · Max 3 MB · .jpg format",
            ],
            ["Pricing", "USD $1 – $60 "],
            ["Free Extension", "Available by sharing on social media"],
            [
              "Creator Awards",
              "Bonus extension at 25, 50, 100, and 200 photos",
            ],
            [
              "Extension Deadline",
              "Apply at least 1 month before your current extension expires",
            ],
            ["Support Email", "help@yogarefer.com"],
          ].map(([label, value]) => (
            <div
              key={label}
              style={{
                borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
                paddingBottom: isMobile ? 8 : 0,
              }}
            >
              <Text type="secondary" style={{ fontSize: 11 }}>
                {label}
              </Text>
              <div>
                <Text style={{ fontSize: 13 }}>{value}</Text>
              </div>
            </div>
          ))}
        </div>
      </Card>

      <Collapse
        defaultActiveKey={[
          "image",
          "technical",
          "upload",
          "extension",
          "awards",
          "violations",
          "medialink",
          "privacy",
          "faq",
        ]}
        bordered={false}
        style={{ background: "transparent", marginBottom: 8 }}
      >
        {/* Image Quality Rules */}
        <Panel
          header={
            <>
              <CheckCircleOutlined
                style={{ color: "#52c41a", marginRight: 8 }}
              />
              Image Quality Rules
            </>
          }
          key="image"
          style={panelStyle}
        >
          <SectionTitle
            icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
          >
            Allowed
          </SectionTitle>
          <ScrollTable
            style={sectionGap}
            dataSource={imageQualityAllowed}
            columns={[
              {
                title: "Category",
                dataIndex: "category",
                width: 140,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Description", dataIndex: "description" },
            ]}
            pagination={false}
            size="small"
          />

          <SectionTitle
            icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
          >
            Not Allowed
          </SectionTitle>
          <ScrollTable
            style={sectionGap}
            dataSource={imageQualityNotAllowed}
            columns={[
              {
                title: "Category",
                dataIndex: "category",
                width: 140,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Description", dataIndex: "description" },
            ]}
            pagination={false}
            size="small"
          />

          <SectionTitle
            icon={<InfoCircleOutlined style={{ color: "#1677ff" }} />}
          >
            Image Quality Criteria
          </SectionTitle>
          <ScrollTable
            dataSource={imageCriteria}
            columns={[
              {
                title: "Aspect",
                dataIndex: "aspect",
                width: 110,
                render: (v) => <Text strong>{v}</Text>,
              },
              {
                title: "Correct",
                dataIndex: "correct",
                render: (v) => <Text style={{ color: "#389e0d" }}>{v}</Text>,
              },
              {
                title: "Avoid",
                dataIndex: "avoid",
                render: (v) => <Text style={{ color: "#cf1322" }}>{v}</Text>,
              },
            ]}
            pagination={false}
            size="small"
          />

          <Alert
            style={{ marginTop: 14 }}
            type="info"
            showIcon={false}
            message={
              <div>
                <Text strong>Best Image Features:</Text>
                <ul style={{ margin: "6px 0 0 0", paddingLeft: 18 }}>
                  <li>White or single-colour background</li>
                  <li>Multiple angles of the pose</li>
                  <li>Book-quality clarity</li>
                </ul>
              </div>
            }
          />
        </Panel>

        {/* Technical Details */}
        <Panel
          header={
            <>
              <FileImageOutlined style={{ marginRight: 8 }} />
              Technical Requirements
            </>
          }
          key="technical"
          style={panelStyle}
        >
          <ScrollTable
            dataSource={technicalDetails}
            columns={[
              {
                title: "Detail",
                dataIndex: "detail",
                width: 110,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Requirement", dataIndex: "requirement" },
              {
                title: "Note",
                dataIndex: "note",
                render: (v) => <Text type="secondary">{v}</Text>,
              },
            ]}
            pagination={false}
            size="small"
          />
          <Alert
            style={{ marginTop: 12 }}
            type="warning"
            showIcon
            message="Your image will be resized and adjusted by our editing team to suit the yoga pose after approval."
          />
          <div style={{ marginTop: 14 }}>
            <Text strong>Editing Process (Free):</Text>
            <ul
              style={{
                margin: "6px 0 0 0",
                paddingLeft: 18,
                color: "rgba(0,0,0,0.65)",
              }}
            >
              <li>Background will be removed and changed to white.</li>
              <li>Pixel size will be adjusted to suit the yoga pose.</li>
              <li>
                Image will be converted to .webp format and reduced to under 50
                KB.
              </li>
            </ul>
          </div>
        </Panel>

        {/* Upload Limits */}
        <Panel
          header={
            <>
              <ClockCircleOutlined style={{ marginRight: 8 }} />
              Upload Limits & Processing Time
            </>
          }
          key="upload"
          style={panelStyle}
        >
          {/* Stack vertically on mobile, side-by-side on desktop */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: 16,
            }}
          >
            <div style={{ minWidth: 0 }}>
              <Text strong style={{ display: "block", marginBottom: 8 }}>
                Upload Limits
              </Text>
              <Table
                style={{ width: "100%" }}
                dataSource={uploadLimits}
                columns={[
                  {
                    title: "Period",
                    dataIndex: "period",
                    render: (v) => <Text strong>{v}</Text>,
                  },
                  { title: "Limit", dataIndex: "limit" },
                ]}
                pagination={false}
                size="small"
                scroll={{ x: true }}
              />
            </div>
            <div style={{ minWidth: 0 }}>
              <Text strong style={{ display: "block", marginBottom: 8 }}>
                Processing Time
              </Text>
              <Table
                style={{ width: "100%" }}
                dataSource={processingTime}
                columns={[
                  {
                    title: "Day",
                    dataIndex: "day",
                    render: (v) => <Text strong>{v}</Text>,
                  },
                  { title: "Time", dataIndex: "time" },
                ]}
                pagination={false}
                size="small"
                scroll={{ x: true }}
              />
            </div>
          </div>
        </Panel>

        {/* Media Link Counting */}
        <Panel
          header={
            <>
              <InfoCircleOutlined style={{ marginRight: 8 }} />
              Media Link Counting
            </>
          }
          key="medialink"
          style={panelStyle}
        >
          <Paragraph
            style={{ color: "rgba(0,0,0,0.65)", fontSize: isMobile ? 13 : 14 }}
          >
            If a single image shows two asanas combined, it counts as 2 media
            links because it will appear in the variations of both asanas. Three
            asanas in one image counts as 3 media links.
          </Paragraph>
          <ScrollTable
            dataSource={mediaLinkCounting}
            columns={[
              {
                title: "Asana Name",
                dataIndex: "example",
                render: (v) => (
                  <Text strong style={{ fontSize: 12 }}>
                    {v}
                  </Text>
                ),
              },
              {
                title: "Links Used",
                dataIndex: "count",
                width: 110,
                render: (v) => (
                  <Tag color="orange" style={{ whiteSpace: "nowrap" }}>
                    {v}
                  </Tag>
                ),
              },
              { title: "Breakdown", dataIndex: "note" },
            ]}
            pagination={false}
            size="small"
          />
        </Panel>

        {/* Extension Plans */}
        <Panel
          header={
            <>
              <ClockCircleOutlined style={{ marginRight: 8 }} />
              Extension Plans
            </>
          }
          key="extension"
          style={panelStyle}
        >
          <Alert
            type="warning"
            showIcon
            message="Apply for an extension at least 1 month before your current extension expires."
            style={{ marginBottom: 16 }}
          />

          <Text strong style={{ display: "block", marginBottom: 6 }}>
            Free Extension — Image Sequence
          </Text>
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: 10, fontSize: 12 }}
          >
            Sharing is only required for images 2 to 20. From the 21st image
            onwards, no sharing is needed.
          </Text>
          <ScrollTable
            dataSource={extensionSequence}
            columns={[
              {
                title: "Image",
                dataIndex: "sequence",
                width: 120,
                render: (v) => (
                  <Text strong style={{ fontSize: 12 }}>
                    {v}
                  </Text>
                ),
              },
              {
                title: "Extension",
                dataIndex: "extension",
                width: 110,
                render: (v) => (
                  <Tag color="green" style={{ whiteSpace: "nowrap" }}>
                    {v}
                  </Tag>
                ),
              },
              { title: "What to Do", dataIndex: "action" },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 20 }}
          />

          <Text strong style={{ display: "block", marginBottom: 6 }}>
            Free Extension Plans (by Social Sharing)
          </Text>
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: 10, fontSize: 12 }}
          >
            First duration = Media link only. Second duration = Media link with
            logo.
          </Text>
          <ScrollTable
            dataSource={freeExtensionPlans}
            columns={[
              {
                title: "Plan",
                dataIndex: "plan",
                width: 80,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "What to Do", dataIndex: "action", width: 200 },
              { title: "Plan 1 (≤20)", dataIndex: "p1", width: 110 },
              { title: "Plan 2 (≤50)", dataIndex: "p2", width: 110 },
              { title: "Plan 3 (≤100)", dataIndex: "p3", width: 110 },
              { title: "Plan 4 (≤200)", dataIndex: "p4", width: 110 },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 20 }}
          />

          <Text strong style={{ display: "block", marginBottom: 6 }}>
            Paid Extension Plans (USD)
          </Text>
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: 10, fontSize: 12 }}
          >
            First price = Media link only. Second price = Media link with logo.
            All prices in US Dollars.
          </Text>
          <ScrollTable
            dataSource={paidPlans}
            columns={[
              {
                title: "Plan",
                dataIndex: "plan",
                width: 80,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Duration", dataIndex: "duration", width: 90 },
              { title: "Plan 1 (≤20)", dataIndex: "p1", width: 100 },
              { title: "Plan 2 (≤50)", dataIndex: "p2", width: 100 },
              { title: "Plan 3 (≤100)", dataIndex: "p3", width: 100 },
              { title: "Plan 4 (≤200)", dataIndex: "p4", width: 100 },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 14 }}
          />

          <div style={{ marginTop: 10 }}>
            <Text strong>Accepted Payment Methods:</Text>
            <div
              style={{
                marginTop: 6,
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              {[
                "Credit / Debit Card (Visa, MasterCard)",
                "Google Pay / Apple Pay / PhonePe",
                "Bank Transfer (select countries)",
                "Upi Transaction",
              ].map((m) => (
                <Tag key={m} color="blue">
                  {m}
                </Tag>
              ))}
            </div>
          </div>

          <Divider />

          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Sharing Rules (Required for Free Extension)
          </Text>
          <ScrollTable
            dataSource={sharingRules}
            columns={[
              {
                title: "Rule",
                dataIndex: "rule",
                width: 140,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Description", dataIndex: "description" },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 12 }}
          />

          <Divider />

          <Text strong style={{ display: "block", marginBottom: 6 }}>
            Bonus Extension for Followers
          </Text>
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: 10, fontSize: 12 }}
          >
            This is added as a bonus on top of your existing extension.
          </Text>
          <ScrollTable
            dataSource={followerBonus}
            columns={[
              {
                title: "Followers",
                dataIndex: "followers",
                width: 110,
                render: (v) => <Text strong>{v}</Text>,
              },
              {
                title: "Media Link Only",
                dataIndex: "mediaOnly",
                render: (v) => <Tag color="cyan">{v}</Tag>,
              },
              {
                title: "With Logo",
                dataIndex: "withLogo",
                render: (v) => <Tag color="purple">{v}</Tag>,
              },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 12 }}
          />

          <Alert
            type="info"
            showIcon
            message="Logo Specifications"
            description={
              <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                <li>Placement: Bottom corner of the image</li>
                <li>Opacity: 50% watermark</li>
                <li>Size: 150 x 150 pixels</li>
                <li>Send your logo to: extend@yogarefer.com</li>
                <li>
                  Logo is added within 24 hours. When the extension ends,
                  watermarked images are automatically removed. Your original
                  images remain permanently.
                </li>
              </ul>
            }
            style={{ marginTop: 12 }}
          />
        </Panel>

        {/* Creator Awards */}
        <Panel
          header={
            <>
              <SafetyCertificateOutlined style={{ marginRight: 8 }} />
              Creator Awards
            </>
          }
          key="awards"
          style={panelStyle}
        >
          <Text
            type="secondary"
            style={{ display: "block", marginBottom: 10, fontSize: 13 }}
          >
            Awards are added as a bonus on top of your existing extension.
          </Text>
          <ScrollTable
            dataSource={creatorAwards}
            columns={[
              {
                title: "Images Uploaded",
                dataIndex: "images",
                width: 130,
                render: (v) => <Tag color="gold">{v} images</Tag>,
              },
              {
                title: "Award Level",
                dataIndex: "award",
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Benefit", dataIndex: "benefit" },
            ]}
            pagination={false}
            size="small"
          />
          <Alert
            style={{ marginTop: 14 }}
            type="success"
            showIcon
            message="Earn Extra Extensions by Reporting Errors"
            description="If you identify and report inaccuracies in yoga content, pose names, images, or the dictionary on yogarefer.com, you will receive a 2-day extension for each valid correction. Maximum of 10 corrections per month."
          />
        </Panel>

        {/* Rule Violations */}
        <Panel
          header={
            <>
              <WarningOutlined style={{ color: "#fa8c16", marginRight: 8 }} />
              Rule Violations & Penalties
            </>
          }
          key="violations"
          style={panelStyle}
        >
          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Warning System
          </Text>
          <ScrollTable
            dataSource={penalties}
            columns={[
              {
                title: "Offense",
                dataIndex: "offense",
                width: 80,
                render: (v) => <Text strong>{v}</Text>,
              },
              {
                title: "Penalty",
                dataIndex: "penalty",
                render: (v) => <Tag color="red">{v}</Tag>,
              },
              { title: "Appeal Method", dataIndex: "appeal" },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 16 }}
          />

          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Immediate Ban (No Warning)
          </Text>
          <ScrollTable
            dataSource={directBan}
            columns={[
              {
                title: "Reason",
                dataIndex: "reason",
                width: 180,
                render: (v) => (
                  <Text strong style={{ color: "#cf1322" }}>
                    {v}
                  </Text>
                ),
              },
              { title: "Description", dataIndex: "description" },
            ]}
            pagination={false}
            size="small"
          />
          <Alert
            style={{ marginTop: 14 }}
            type="warning"
            showIcon
            message="To report an inappropriate image, click the Report button on the image. Action will be taken within 24 hours."
          />
        </Panel>

        {/* Privacy & Data */}
        <Panel
          header={
            <>
              <SafetyCertificateOutlined style={{ marginRight: 8 }} />
              Privacy & Data
            </>
          }
          key="privacy"
          style={panelStyle}
        >
          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Data Retention
          </Text>
          <ScrollTable
            dataSource={privacyData}
            columns={[
              {
                title: "Data Type",
                dataIndex: "type",
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Retention Period", dataIndex: "period" },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 16 }}
          />

          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Privacy Protection
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              marginBottom: 16,
            }}
          >
            {[
              "GPS information is automatically removed from all images.",
              "No facial data analysis is performed.",
              "Personal information is encrypted.",
              "Your data is never shared with third parties without your permission.",
            ].map((item) => (
              <div
                key={item}
                style={{ display: "flex", gap: 8, alignItems: "flex-start" }}
              >
                <CheckCircleOutlined
                  style={{ color: "#52c41a", marginTop: 3, flexShrink: 0 }}
                />
                <Text style={{ fontSize: 13 }}>{item}</Text>
              </div>
            ))}
          </div>

          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Your Rights
          </Text>
          <ScrollTable
            dataSource={userRights}
            columns={[
              {
                title: "Right",
                dataIndex: "right",
                width: 140,
                render: (v) => <Text strong>{v}</Text>,
              },
              { title: "Description", dataIndex: "description" },
            ]}
            pagination={false}
            size="small"
            style={{ marginBottom: 16 }}
          />

          <Alert
            type="info"
            showIcon
            message="Rights held by Yogarefer.com"
            description={
              <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                <li>Lifetime viewing rights only.</li>
                <li>
                  Permission to share images on the website and its social media
                  channels.
                </li>
                <li>
                  Permission to edit images to meet website quality standards.
                </li>
              </ul>
            }
          />
        </Panel>

        {/* FAQ */}
        <Panel
          header={
            <>
              <QuestionCircleOutlined style={{ marginRight: 8 }} />
              Frequently Asked Questions
            </>
          }
          key="faq"
          style={panelStyle}
        >
          {[
            {
              q: "How many images can I upload?",
              a: "10 per day, 50 per week, and 200 images in total.",
            },
            {
              q: "What camera do I need?",
              a: "Your mobile phone is sufficient. HD quality is acceptable.",
            },
            {
              q: "Why are AI images not allowed?",
              a: "The platform is dedicated to showing real human yoga practice only.",
            },
            {
              q: "How will my name be displayed?",
              a: "For example: Rajesh — @rajeshyoga (your Instagram handle if you wish to include it).",
            },
            {
              q: "What happens after 6 months?",
              a: "Your image and your name remain permanently on the site. Only your media link will expire.",
            },
            {
              q: "Can I delete my image?",
              a: "Yes. Click Delete in your Dashboard. The image will be removed within 15 days.",
            },
            {
              q: "What happens if I reach the 24-month extension limit?",
              a: "Your image is permanent. Only the media link expires. You cannot re-upload the same image.",
            },
          ].map(({ q, a }) => (
            <div key={q} style={{ marginBottom: 14 }}>
              <Text strong style={{ fontSize: isMobile ? 13 : 14 }}>
                {q}
              </Text>
              <div>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  {a}
                </Text>
              </div>
            </div>
          ))}
        </Panel>
      </Collapse>

      {/* Support */}
      <Card
        title="Help & Support"
        style={{ marginTop: 4 }}
        styles={colStyle}
        size={isMobile ? "small" : "default"}
      >
        <ScrollTable
          dataSource={[
            {
              key: 1,
              need: "General Help",
              email: "help@yogarefer.com",
              response: "Within 24 hours",
            },
            {
              key: 2,
              need: "Complaints",
              email: "report@yogarefer.com",
              response: "Within 24 hours",
            },
            {
              key: 3,
              need: "Extensions",
              email: "extend@yogarefer.com",
              response: "Within 48 hours",
            },
          ]}
          columns={[
            {
              title: "Topic",
              dataIndex: "need",
              render: (v) => <Text strong>{v}</Text>,
            },
            {
              title: "Email",
              dataIndex: "email",
              render: (v) => <a href={`mailto:${v}`}>{v}</a>,
            },
            { title: "Response Time", dataIndex: "response" },
          ]}
          pagination={false}
          size="small"
        />
        <Alert
          style={{ marginTop: 14 }}
          type="warning"
          showIcon
          message="Important Notices"
          description={
            <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
              <li>
                These images are for reference only. Do not practise without the
                guidance of a certified yoga teacher.
              </li>
              <li>
                This is not medical advice. Consult your doctor before beginning
                any yoga practice.
              </li>
              <li>
                All image rights belong to the creator. Yogarefer.com holds only
                permanent free viewing rights.
              </li>
              <li>
                We are not responsible for injuries incurred during practice.
                Users practise at their own risk.
              </li>
            </ul>
          }
        />
      </Card>
    </div>
  );
};

// ─────────────────────────────────────────────
// MAIN PAGE
// ─────────────────────────────────────────────

const UserPage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        role="user"
      />
      <Layout
        style={{
          marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
          transition: "margin-left 0.3s ease",
          width: isMobile ? "100%" : undefined,
          minWidth: 0, // prevents flexbox overflow
        }}
      >
        <Header
          className="MainHeader"
          style={{ display: "flex", alignItems: "center", padding: "0 16px" }}
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <Text style={{ fontSize: isMobile ? 17 : 20, fontWeight: "bold" }}>
            Rules & Guidelines
          </Text>
        </Header>

        <Content
          style={{
            padding: isMobile ? "12px" : "20px",
            overflowX: "hidden",
          }}
        >
          <RulesContent isMobile={isMobile} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserPage;
